import {SelectItem} from "./select-item";
import BaseModel from "../default/base-model";

export class Replenishment extends BaseModel {
    id: number;
    repetition_frequency: RepetitionFrequency;
    date?: Date;
    time?: Date;
    type: Type;
    result: Result;
    prediction_technique: PredictionTechnique;
    service_level: ServiceLevel;
    month_forecast: number;


    constructor(
        type: Type = Type.MANUAL,
        result: Result = Result.LIFE_CYCLE,
        predictionTechnique: PredictionTechnique = PredictionTechnique.SMA,
        serviceLevel: ServiceLevel = ServiceLevel.P85,
        repetitionFrequency: RepetitionFrequency = RepetitionFrequency.MENSAL,
    ) {
        super();
        this.id = 0;
        this.repetition_frequency = repetitionFrequency;
        this.date = new Date();
        this.time = new Date();
        this.type = type;
        this.result = result;
        this.prediction_technique = predictionTechnique;
        this.service_level = serviceLevel;
        this.month_forecast = 3; // Default value
    }
}

export enum Type {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC'
}

export enum Result {
    LIFE_CYCLE = 'LIFE_CYCLE',
    USEFUL_LIFE = 'USEFUL_LIFE',
}

export enum PredictionTechnique {
    SMA = 'SMA',
    ARIMA = 'ARIMA',
    SARIMAX = 'SARIMAX',
    HOLT_WINTERS = 'HOLT_WINTERS',
    LSTM = 'LSTM'
}

export enum ServiceLevel {
    P85 = '85.0',
    P90 = '90.0',
    P95 = '95.0',
    P995 = '99.5'
}

export enum RepetitionFrequency {
    NAO_REPETE = 1,
    SEMANAL = 2,
    MENSAL = 3,
}

export const PredictionTechniqueList: (SelectItem & { legend: string })[] = [
    { label: 'SMA', value: PredictionTechnique.SMA, legend: `A <b>SMA (Simple Moving Average)</b> calcula a média de quaisquer dados em um período definido, atualizando-a conforme novos dados chegam para mostrar tendências claramente.` },
    { label: 'ARIMA', value: PredictionTechnique.ARIMA, legend: `<b>ARIMA (Autoregressive Integrated Moving Average)</b> é um modelo de previsão que utiliza dados passados para prever valores futuros. Ele ajusta tendências (AR), diferenças (I) e médias móveis (MA) para melhorar a precisão. ` },
    { label: 'SARIMAX', value: PredictionTechnique.SARIMAX, legend: `<b>SARIMAX (Seasonal AutoRegressive Integrated Moving Average with eXogenous regressors)</b> estende o ARIMA adicionando sazonalidade (S) e fatores externos (X). É ótimo para prever dados com padrões repetidos, ao mesmo tempo em que considera influências externas.` },
    { label: 'HOLT WINTERS', value: PredictionTechnique.HOLT_WINTERS, legend: `<b>Holt-Winters</b> é um método de previsão para dados com tendências e sazonalidade. Ele utiliza médias ponderadas — nível de suavização, tendência e padrões sazonais — para prever valores futuros com mais precisão.` },
    { label: 'LSTM', value: PredictionTechnique.LSTM, legend: `<b>LSTM (Long Short-Term Memory)</b> é um tipo de modelo de IA que aprende padrões em dados sequenciais. Ele se lembra de tendências de longo prazo e se adapta a mudanças, o que o torna ideal para previsões complexas.`},
]

export const RepetitionFrequencyList: SelectItem[] = [
    { label: 'Não repete', value: RepetitionFrequency.NAO_REPETE },
    { label: 'Semanal', value: RepetitionFrequency.SEMANAL },
    { label: 'Mensal', value: RepetitionFrequency.MENSAL },
]

export class ReplenishmentSpareParts extends BaseModel {
    id: number;
    material_number: string;
    description_portuguese: string;
    description_english: string;
    stock: number;
    safety_stock: number;
    expected_quantity: number;
    quantity_consumed: number;
    quantity_produced: number;
    quantity_material_replacement: number;
    lead_time: number;
    open_purchase_order: number;
    forecast_material_shortage: number;
    next_purchase_date?: Date;
    life_cycle: Result;
    life_cycle_value: number;
    stock_image?: string;

    constructor() {
        super();
        this.id = 0;
        this.material_number = '';
        this.description_portuguese = '';
        this.description_english = '';
        this.stock = 0;
        this.safety_stock = 0;
        this.expected_quantity = 0;
        this.quantity_consumed = 0;
        this.quantity_produced = 0;
        this.quantity_material_replacement = 0;
        this.lead_time = 0;
        this.open_purchase_order = 0;
        this.forecast_material_shortage = 0;
        this.next_purchase_date = undefined;
        this.life_cycle = Result.LIFE_CYCLE;
        this.life_cycle_value = 0;
        this.stock_image = '';
    }

    get formatedNextPurchaseDate(): string {
        return this.next_purchase_date ? this.next_purchase_date.toISOString().split('T')[0] : '';
    }
}

export class ForecastProcessed {
    status: StatusForecastProcessed;
    processing_end_date: string;

    constructor() {
        this.status = StatusForecastProcessed.UNAVAILABLE;
        this.processing_end_date = "";
    }
}

export enum StatusForecastProcessed {
    PROCESSING = 1,
    COMPLETED = 2,
    UNAVAILABLE = -1,
}
